
import { Component, inject } from '@angular/core';
import { AppdataService } from '../../../service/appdata.service';
import { serverurl } from '../../../../environments/environment';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { StreamoverviewComponent } from './streamoverview/streamoverview.component';

@Component({
  selector: 'app-newstream',
  standalone: false,

  templateUrl: './newstream.component.html',
  styleUrl: './newstream.component.scss'
})
export class NewstreamComponent {
  categories: any[] = [];
  tracks: any[] = [];
  serverurl = serverurl;
  readonly dialogRef = inject(MatDialogRef<NewstreamComponent>);
  readonly dialog = inject(MatDialog);
  constructor(
    private appdata: AppdataService
  ) {
    appdata.streamCategories.subscribe((data) => {
      this.categories = data;
    });

    appdata.tracks.subscribe((data) => {
      this.tracks = data;
      if (data) this.sorCatsAndTracks();
    });

  }

  async sorCatsAndTracks() {
    for await (let cat of this.categories) {
      cat.tracks = this.tracks?.filter((track: any) => track?.categoryId == cat.id);
    }
  }

  onClickCat(cat: any) {
    let dia = this.dialog.open(StreamoverviewComponent, {
      data: { "category": cat },
      width: '1346px',
      panelClass: 'flex-dialog'
    });

    dia.afterClosed().subscribe((data) => {
      if (data === 'newTrack') {
        this.dialogRef.close('newTrack');
      }
    });

  }

  close() {
    this.dialogRef.close();
  }
}
